let _ = require("ES/lib/lodash");

export default function(Displaylists, event){
	if(!event.is_mp_event || _.includes(event.flags_as_array, "bookmenow")){
		return 0;
	}
	let whitelabel = _.get(Displaylists, ["universal", "whitelabels", event.bureauID]);

	let espeakers_commission = parseFloat(_.get(event, ["key_values", "MP_ESPEAKERS_COMMISSION"], (whitelabel ? whitelabel.mp_espeakers_commission : 0.1))) * 100;
	let thebureau_commission = parseFloat(_.get(event, ["key_values", "MP_WHITELABEL_COMMISSION"], (whitelabel ? whitelabel.mp_bureau_commission : 0))) * 100;

	return Math.max(0, espeakers_commission + thebureau_commission);
}



// WEBPACK FOOTER //
// ./src/utils/getMPCommissionForEvent.js